import { Tabs as AntdTabs } from 'antd'
import { jsxutils } from 'apprise-frontend-core/utils/common'
import { Component, useDeferredComponentProps } from 'apprise-ui/component/component'
import { Styled } from 'apprise-ui/component/model'
import * as React from 'react'
import { DotIcon } from '../utils/icons'
import "./styles.scss"
import { Tab } from './tab'



type TabsProps  <T extends string=string> =  Styled & {

    selectedTab: T
    onSelection: (tab: T) => void
}


export const ControlledTabs = <T extends string=string>  (props: React.PropsWithChildren<Partial<TabsProps<T> & {

    tabsStyle: React.CSSProperties
    tabsClassname: string

}>>) => {


    const { onSelection = () => { }, selectedTab, children, ...rest } = props

    const componentProps = useDeferredComponentProps()

    // complements a set of props with defaults for the relevant ones.
    const adaptProps = (position: number, props: any) => {

        const { id, label, icon, defaultTab, children = <div>tab {position + 1}</div>, ...rest } = componentProps.getComponentProps(props)

        return {
            id: id ?? `${position + 1}`,
            label: label ?? `tab ${position + 1}`,
            icon: icon ?? <DotIcon />,
            defaultTab,
            children,

            ...rest

        }
    }

    // adapts children props and transforms children into <Tab>s if they are not already.
    const childprops = jsxutils().elementsIn(children).filter(jsxutils().isElementOf(Tab)).map((e, i) => adaptProps(i, e.props))

    const defaultTab = childprops.find(p => p.defaultTab) ?? childprops?.[0]

    const activeId = selectedTab ?? defaultTab?.id

    const activeTab = childprops.find(p => p.id === activeId) ?? defaultTab



    // enables animation after mount, to avoid stutter. 
    // with a delay as the anmation itself is delayed, and if we run first we will have it always enabled.
    const ref = React.useRef(false)

    React.useEffect(() => {

        const ts = setTimeout(() => ref.current = true, 100)
        return () => clearTimeout(ts)

    }, [])


    return <Component name="tabs" {...rest}>

        <AntdTabs style={props.tabsStyle} className={props.tabsClassname} animated={ref.current} activeKey={activeTab?.id} onChange={onSelection as any} items={childprops.map(props => {

            const tab = <Tab {...props} />

            return { label: tab, key: props.id, disabled: props.disabled }

        })}

        />
    </Component>

}
